import { render, staticRenderFns } from "./ProjectCardTrialsList.vue?vue&type=template&id=4f0f2cf0&scoped=true&"
import script from "./ProjectCardTrialsList.vue?vue&type=script&lang=js&"
export * from "./ProjectCardTrialsList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardTrialsList.vue?vue&type=style&index=0&id=4f0f2cf0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f2cf0",
  null
  
)

export default component.exports